import {
  CHANGE_PASSWORD_OPEN_DIALOG,
  CHANGE_PASSWORD_CLOSE_DIALOG,
  CHANGE_PHONE_PASSWORD_OPEN_DIALOG,
  CHANGE_PHONE_PASSWORD_CLOSE_DIALOG,
  CREATE_PHONE_LOGIN_OPEN_DIALOG,
  CREATE_PHONE_LOGIN_CLOSE_DIALOG,
} from '@xmatters/redux/actions/changePassword';

export const defaultState = {
  isChangePasswordDialogOpen: false,
  isChangePhonePasswordDialogOpen: false,
  isCreatePhoneLoginDialogOpen: false,
};

export default function changePassword(state = defaultState, action) {
  switch (action.type) {
    case CHANGE_PASSWORD_OPEN_DIALOG:
      return {
        ...state,
        isChangePasswordDialogOpen: true,
      };
    case CHANGE_PASSWORD_CLOSE_DIALOG:
      return {
        ...state,
        isChangePasswordDialogOpen: false,
      };
    case CHANGE_PHONE_PASSWORD_OPEN_DIALOG:
      return {
        ...state,
        isChangePhonePasswordDialogOpen: true,
      };
    case CHANGE_PHONE_PASSWORD_CLOSE_DIALOG:
      return {
        ...state,
        isChangePhonePasswordDialogOpen: false,
      };
    case CREATE_PHONE_LOGIN_OPEN_DIALOG:
      return {
        ...state,
        isCreatePhoneLoginDialogOpen: true,
      };
    case CREATE_PHONE_LOGIN_CLOSE_DIALOG:
      return {
        ...state,
        isCreatePhoneLoginDialogOpen: false,
      };
    default:
      return state;
  }
}
